import api from './clients';

export const comprobantesApi = {
  getAll: () => api.get('/comprobantes').then(res => res.data.data),
  getById: (id: number) => api.get(`/comprobantes/${id}`).then(res => res.data.data),
  create: (data: any) => api.post('/comprobantes', data).then(res => res.data.data),
  update: (id: number, data: any) => api.put(`/comprobantes/${id}`, data).then(res => res.data.data),
  delete: (id: number) => api.delete(`/comprobantes/${id}`).then(res => res.data),
  generatePDF: (id: number) => api.post(`/comprobantes/${id}/pdf`).then(res => res.data),
  downloadPDF: (id: number) => api.get(`/comprobantes/${id}/pdf`, { responseType: 'blob' }),
};